<div style="margin: 20px; min-height: 700px; min-width: 1200px;">
  <div class="btn-group">
    <p-button name="add" [routerLink]="'./user'" title="Dodaj użytkownika" label="Dodaj użytkownika"></p-button>
  </div>
  <p-table #dt [value]="data" [columns]="cols" [paginator]="true" [rows]="30" [(first)]="parent.first">
    <ng-template pTemplate="caption">
      <div style="text-align: right;">
        <fa-icon icon="search" style="margin: 4px 5px 0 0"></fa-icon>
        <input pInputText size="50" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width: auto;" />
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" width="{{col.width}}" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
        <th width="13%">Akcja</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr style="white-space: normal; overflow-wrap: break-word;" class="{{rowData.active ? null : 'no-active'}}">
        <td *ngFor="let col of columns">
          <span>{{rowData[col.field]}}</span>
        </td>
        <td>
          <fa-stack *ngIf="rowData.active" size="1x" style="cursor: pointer; float: right;" (click)="deleteUser(rowData)" title="Usuń">
            <fa-icon icon="square" stackItemSize="2x"></fa-icon>
            <fa-icon icon="times" [inverse]="true" stackItemSize="1x"></fa-icon>
          </fa-stack>
          <fa-stack size="1x" style="cursor: pointer; float: right;" [routerLink]="'./user/' + rowData.id" title="Edytuj">
            <fa-icon icon="square" stackItemSize="2x"></fa-icon>
            <fa-icon icon="edit" [inverse]="true" stackItemSize="1x"></fa-icon>
          </fa-stack>
          <fa-stack *ngIf="rowData.active" size="1x" style="cursor: pointer; float: right;" [routerLink]="'./user/' + rowData.id + '/roles'" title="Role">
            <fa-icon icon="square" stackItemSize="2x"></fa-icon>
            <fa-icon icon="theater-masks" [inverse]="true" stackItemSize="1x"></fa-icon>
          </fa-stack>
          <fa-stack *ngIf="rowData.active" size="1x" style="cursor: pointer; float: right;" [routerLink]="'./user/' + rowData.id + '/config'" title="Uprawnienia">
            <fa-icon icon="square" stackItemSize="2x"></fa-icon>
            <fa-icon icon="cog" [inverse]="true" stackItemSize="1x"></fa-icon>
          </fa-stack>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
